import { render, staticRenderFns } from "./Profile.Comment.vue?vue&type=template&id=12c6641c&scoped=true"
import script from "./Profile.Comment.vue?vue&type=script&lang=js"
export * from "./Profile.Comment.vue?vue&type=script&lang=js"
import style0 from "./Profile.Comment.vue?vue&type=style&index=0&id=12c6641c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c6641c",
  null
  
)

export default component.exports